import React, { Component, Fragment } from 'react';
import TagManager from 'react-gtm-module';

import MedidorIcon from '../img/icons-2025/medidor.svg';
import TanqueIcon from '../img/icons-2025/tanques-tanque-generico.svg';
import CilindroIcon from '../img/icons-2025/cilindros-normal.svg';
import AutogasIcon from '../img/icons-2025/autogas.svg';

import GridBox from './GridBox';
import BreadCrumb from './BreadCrumb';
import {available} from '../config.js';


var newServices = [
	{
		name: "Cilindro",
		desc: "Usas cilindros de gas en alguno de sus distintos formatos: 05, 11, 15 o 45 kilos.",
		icon: CilindroIcon,
		link: "/adminitracion_cuentas/cilindro/asociar"
	},
	{
		name: "Granel Habitacional",
		desc: "Tienes un tanque de gas en tu domicilio y lo abastecemos de acuerdo a tu necesidad",
		icon: TanqueIcon,
		link: "/adminitracion_cuentas/granel/asociar"

	},
	{
		name: "Autogas",
		desc: "Tienes un Kit y tanque de GLP instalado en tu vehículo",
		icon: AutogasIcon,
		link: "/adminitracion_cuentas/autogas/asociar"

	},
	{
		name: "Medidor",
		desc: "Si mensualmente recibes una boleta en tu hogar por el consumo de gas",
		icon: MedidorIcon,
		link: "/adminitracion_cuentas/medidor/asociar"

	}
];
export default class SeleccionarServicioAgregar extends Component {
	componentDidMount() {
		this.props.changeHeaderClass("medium");    	
    }

	sendCustomEventGTM({event, metadata={}}){
		if (!event) return;
		const {dni,email,id,sales_force_id,name,last_name,phone} = this.props.user;
		TagManager.dataLayer({ 
			dataLayer:{ event, metadata:{
				dni,
				email,
				id,
				sales_force_id,
				name,
				last_name,
				phone,
				...metadata
			}} 
		});
	}

	render() {
		var breadCrumbOptions = [
			{title: "Agregar Servicios"},
		];
		return (
          	<Fragment>
				 
			<div className="section-title">
					<h1>Seleccione Servicio que desea Agregar</h1>
					<BreadCrumb options={breadCrumbOptions} />					
				</div>
          	<div className="service-choose-container margin-sides-40 margin-top-80">
	          	{newServices.map((service, i) => {
		          	if(!available.granel && service.name === "Granel Habitacional") return null;
					  if(!available.cilindro && service.name === "Cilindro") return null;
					  if(!available.autogas && service.name === "Autogas") return null;

	          		return(
					<GridBox 
					service={service} 
					key={i} 
					buttonLabel="AGREGAR"
					onButtonHandlerClick={()=>{
						this.sendCustomEventGTM({
							event:"sv_mis_servicios_click_seleccionar",
							metadata:{trigger:service.name}
						});
					}} />);
	          	})}		
          	</div>
          	</Fragment>
		);
	}
};